import Store from "./Store";
import Product from "../../model/product.model";

export default class ProductStore extends Store<Product> {
  protected override name: string = "products";
}
